<template>
  <div class="bet-slip bet-slip-round-robin">
    <div class="bet-slip-content" v-for="bet in betModel" :key="bet.id" :class="{'bgColorWhite' : isScanningCodeForMobile}">
      <!-- Bet Line  -->
      <div class="bet-scroll-wrapper">
        <div>
          <bet-alert-message
            v-if="!bet.IsSuccess"
            error
            withoutIcon
            :description="parseBetErrorMessage(betOptionsResponse)"
          />

          <!-- checkbox geliştirmesi yapıldıktan sonra v-else kaldır -->
          <div v-else>
            <div class="bet-scroll-wrapper">
              <div v-for="selection in bet.Selections" :key="selection.OutComeId">
                <bet-alert-message
                  v-if="!selection.error.IsSuccess"
                  :description="parseBetErrorMessage(selection.error)"
                  :canClose="true"
                  @onRemove="removeBetFromSlipByIndex(selection.OutComeId)"
                />
                <bet-slip-selection
                  v-else
                  class="bet-slip-item-wrapper"
                  :selection="selection"
                  :show-checkbox="showCheckbox"
                  :isChecked="isChecked(selection.OutComeId)"
                  @onBuyPointChange="onRiskChange(bet)"
                  @onRemove="removeBetFromSelections(selection.OutComeId)"
                  @accept="onRiskChange(bet)"
                  @lineChecked="lineChecked(bet, selection, $event)"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          class="bet-slip-item-wrapper append-left set-amount-all-bets-input"
          :class="{ 'mb-0': !$isElectron }"
          style="border-bottom: none"
          v-if="freeWagersViewing === false && bet.IsSuccess"
        >
          <div class="row d-flex align-items-center">
            <div class="col-6">
              <span class="input-span" v-html="$t('BetSlip.Set Amount All Bets').replace('<br>', ' ')"></span>
            </div>

            <div class="col-6">
              <input
                :type="editAbleAllAmount ? 'tel' : 'text'"
                class="form-control bet-slip-form-control w-100"
                @blur="
                  editAbleAllAmount = false;
                  vk_hide();
                "
                @focus="
                  editAbleAllAmount = true;
                  vk_show($event);
                "
                :class="{ filled: !!allBetAmount }"
                :value="editAbleAllAmount || !allBetAmount ? allBetAmount : currencySymbol + '' + allBetAmount"
                @input="
                  allBetAmount = $event.target.value;
                  setAll();
                "
                :placeholder="$t('Risk') + ' ' + currencySymbol"
                onkeydown="return event.keyCode !== 69"
                @keypress="isNumber"
              />
            </div>
          </div>
        </div>

        <div class="bet-slip-item-wrapper mb-0 append-left" style="border-bottom: 0">
          <div class="setter-wrapper" v-if="bet.IsSuccess">
            <div class="title">
              <div class="row">
                <div class="col-6">{{ $t('BetSlip.RoundRobin.Type') }}</div>
                <div class="col-6 title-right">
                  {{ $t('BetSlip.RoundRobin.Stake') }}
                </div>
              </div>
            </div>

            <!-- SINGLE -->
            <div class="single-area sub-text-color" v-if="canDoStraightBet">
              <ParlayPreviewModal2
                :bet="bet"
                :betsFromProp="getCombins(bet, 1)"
                :ref="'preview_straight'"
                :risk-amount="roundRobinTab.straightBetRiskAmount"
                :total-risk-amount="roundRobinTab.straightBetRiskAmount * checkedSelections.length"
                :total-win-amount="straightsToReturn.text"
                :alternative-title="'straight'"
                :parlaySize="1"
              />

              <div class="row">
                <div class="col-6 type">
                  {{ $t('BetSlip.RoundRobin.Single') }}
                </div>
                <div class="col-6">
                  <div class="single-area-right">
                    <div class="factor">{{ bet.Selections.length }}x</div>
                    <div class="input">
                      <bet-slip-risk-input
                        class="w-100"
                        :amount.sync="roundRobinTab.straightBetRiskAmount"
                        @change="onStraightRiskChange($event)"
                        :min="getBetMinLimit(bet)"
                        :max="getBetMaxLimit(bet)"
                        :isCustomLimitControl="true"
                        :limitControl="false"
                        type="RISK"
                      />
                    </div>
                    <div class="info" @click="$refs['preview_straight'][0].openModal()">
                      <info-icon></info-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="single-area sub-text-color" v-for="opt in bet.options.available_types" :key="opt.id">
              <div v-if="opt.parlay_size !== 99">
                <ParlayPreviewModal2
                  :bet="bet"
                  :betsFromProp="getCombins(bet, opt.parlay_size)"
                  :ref="'preview_' + opt.parlay_size"
                  :risk-amount="roundRobinTab.roundRobinsAmounts[opt.parlay_size]"
                  :total-risk-amount="opt.parlay_count * roundRobinTab.roundRobinsAmounts[opt.parlay_size]"
                  :total-win-amount="totalWinFromParlay(opt.parlay_size).text"
                  :parlaySize="opt.parlay_size"
                />

                <div class="row">
                  <div class="col-6 type">
                    {{ getTranslationForFold(opt.parlay_size) }}
                  </div>
                  <div class="col-6">
                    <div class="single-area-right">
                      <div class="factor">{{ opt.parlay_count }}x</div>
                      <div class="input">
                        <bet-slip-risk-input
                          class="w-100"
                          :amount.sync="roundRobinTab.roundRobinsAmounts[opt.parlay_size]"
                          @change="onRRRiskChange($event, opt.parlay_size)"
                          :min="getBetMinLimit(bet)"
                          :max="getBetMaxLimit(bet)"
                          :isCustomLimitControl="true"
                          :limitControl="false"
                          type="RISK"
                        />
                      </div>
                      <div class="info" @click="infoClick(opt.parlay_size)">
                        <info-icon></info-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-else>
                <!-- YANKEE -->
                <ParlayPreviewModal2
                  :bet="bet"
                  :betsFromProp="totalYankeeMatches()"
                  :ref="'preview_yankee'"
                  :risk-amount="roundRobinTab.roundRobinsAmounts['99']"
                  :total-risk-amount="getAllParlayCounts() * roundRobinTab.roundRobinsAmounts['99']"
                  :total-win-amount="totalWinFromYankee2().text"
                  :parlaySize="opt.parlay_size"
                />
                <div class="row">
                  <div class="col-6">{{ getYankeeName() }}</div>
                  <div class="col-6">
                    <div class="single-area-right">
                      <div class="factor">{{ opt.parlay_count }}x</div>
                      <div class="input">
                        <bet-slip-risk-input
                          class="w-100"
                          :amount.sync="roundRobinTab.roundRobinsAmounts['99']"
                          @change="onRRRiskChange($event, '99')"
                          :min="getBetMinLimit(bet)"
                          :max="getBetMaxLimit(bet)"
                          type="RISK"
                        />
                      </div>
                      <div class="info" @click="$refs['preview_yankee'][0].openModal()">
                        <info-icon></info-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="betslip-input-error error-3"
            v-if="minBetConditionForRoundRobin(roundRobinTab)"
            v-html="minBetConditionError()"
          ></div>
        </div>
      </div>

      <div class="sticky-wrapper">
        <total-amounts
          class="mt-1"
          :totalBets="getTotalBetsCount()"
          :totalRiskAmount="getTotalRiskAmount()"
          :totalRiskAmountWithoutTax="getTotalRiskAmountWithoutTax()"
          :hideTotalWinAmount="false"
          :total-win-amount="getTotalWinAmount()"
          :showFreePlayIfEligible="true"
          :betOptionsResponse="getRoundRobins()"
          :disable-place-bet-button="minBetConditionForRoundRobin(roundRobinTab)"
          :wagerType="getWagerType()"
        ></total-amounts>
      </div>
    </div>
  </div>
</template>

<script>
import BetSlipMixin from './bet-slip-mixin';
import ParlayPreviewModal2 from './ParlayPreviewModal2';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { setChecked, isChecked } from '@/views/sports/components/bet-slip/check-bets';
import InfoIcon from '@/views/sports/components/bet-slip/InfoIcon';
import { getRoundRobinCombinations } from '@/views/sports/components/bet-slip/bet-slip-utils';
import snq from 'snq';
import { modifyAmountInput } from '@/utils/common';

export default {
  mixins: [BetSlipMixin],
  components: {
    InfoIcon,
    ParlayPreviewModal2,
  },
  data() {
    return {
      betModel: null,
      allBetAmount: '',
      editAbleAllAmount: false,
    };
  },
  computed: {
    ...mapState({
      roundRobinTab: (state) => state.betSlip.roundRobinTab,
      roundRobins: (state) => state.betSlip.roundRobins,
      activeFreeBet: (state) => state.betSlip.activeFreeBet,
      isScanningCodeForMobile: state => state.settings.isScanningCodeForMobile,
    }),
    ...mapGetters('player', ['currencySymbol']),
    totalRRParlayCount() {
      if (!this.betOptionsResponse.IsSuccess) {
        return 0;
      }
      return this.betOptionsResponse.options.available_types.reduce((a, c) => a + c.parlay_count, 0);
    },
    straightsToReturn() {
      let value = 0;
      if (this.isBetween(this.roundRobinTab.straightBetRiskAmount)) {
        value += this.checkedSelections.reduce((acc, value) => {
          return acc + this.americanToDecimal(value.Odd) * +this.roundRobinTab.straightBetRiskAmount;
        }, 0);
      }

      value = value.toFixed(2);

      return {
        text: `${this.currencySymbol} ${value || '0.00'}`,
        value,
      };
    },
    checkedSelections() {
      return this.betModel[0].Selections;
    },
    canDoStraightBet() {
      return !this.$isElectron;
    },
  },
  methods: {
    ...mapMutations('helper', ['vk_show', 'vk_hide']),
    getRoundRobinCombinations,
    isChecked,
    ...mapMutations({
      setRRStraightBetRiskAmount: 'betSlip/setRRStraightBetRiskAmount',
      setRRFoldBeRiskAmount: 'betSlip/setRRFoldBeRiskAmount',
      setBetOptionsResponse: 'betSlip/setBetOptionsResponse',
    }),
    ...mapActions({
      updateBetFreeWager: 'betSlip/updateBetFreeWager',
      getNewBetOptions: 'betSlip/getNewBetOptions',
      fillRoundRobinData: 'betSlip/fillRoundRobinData',
    }),
    onRiskChange(bet) {
      console.log('onRiskChange', bet);
    },
    getWagerType() {
      return 'round_robin';
    },
    getTotalWinAmount() {
      let total = 0;
      if (this.isBetween(this.roundRobinTab.straightBetRiskAmount)) {
        total += this.checkedSelections.reduce((acc, value) => {
          return (
            acc +
            this.americanToDecimal(value.Odd) *
              this.$taxHelper.applyTaxToWinInputHidden({
                input_win_amount: this.roundRobinTab.straightBetRiskAmount,
              })
          );
        }, 0);
      }

      total += +Object.entries(this.roundRobinTab.roundRobinsAmounts)
        .filter(([_, value]) => !!value)
        .filter(([_, value]) => this.isBetween(value))
        .filter(([name, _]) => name !== 99)
        .reduce((acc, curr) => acc + this.totalWinFromParlay(curr[0]).value, 0);

      total += +this.totalWinFromYankee2WithoutTaxes().value;

      if (parseFloat(total) < 0) {
        return 0;
      }
      var parsedTotal = parseFloat(total);
      this.betOptionsResponse.rrRisk = parseFloat(this.getTotalRiskAmount());
      this.betOptionsResponse.rrTotalWin = parsedTotal;
      return parsedTotal ? parsedTotal.toFixed(2) : '0.00';
    },
    getTotalRiskForRR() {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return 0;
      }

      let total = 0;
      if (this.activeFreeBet) {
        return 0;
      }

      if (this.roundRobinTab.roundRobinsAmounts) {
        const rrs = { ...this.roundRobinTab.roundRobinsAmounts };
        total += Object.entries(rrs)
          .filter(([_, value]) => !!value)
          .filter(([_, value]) => this.isBetween(value))
          .reduce(
            (acc, curr) =>
              acc +
              this.$taxHelper.applyTaxToRiskInputHidden({
                input_risk_amount: rrs[curr[0]],
              }) *
                this.getParlayCountFromOptions(curr[0]),
            0,
          );
      }

      return total;
    },
    getTotalRiskForRR2() {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return 0;
      }

      let total = 0;

      if (this.roundRobinTab.roundRobinsAmounts) {
        const rrs = { ...this.roundRobinTab.roundRobinsAmounts };
        total += Object.entries(rrs)
          .filter(([_, value]) => !!value)
          .filter(([_, value]) => this.isBetween(value))
          .reduce((acc, curr) => acc + rrs[curr[0]] * this.getParlayCountFromOptions(curr[0]), 0);
      }

      return total;
    },
    getTotalRiskAmount() {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return 0;
      }

      let straightBetRiskAmount = +this.roundRobinTab.straightBetRiskAmount;

      straightBetRiskAmount = this.$taxHelper.applyTaxToRiskInputHidden({
        input_risk_amount: straightBetRiskAmount,
      });

      let total = 0;

      if (straightBetRiskAmount && this.isBetween(straightBetRiskAmount)) {
        // BE güncellemesinden sonra checked lar dönmeli.
        //total += this.betModel.bet.line_selections.filter(s => isChecked(s.id)).length;
        total += this.checkedSelections.length * straightBetRiskAmount;
      }

      total += this.getTotalRiskForRR();

      return this.roundAmount(total);
    },

    getTotalRiskAmountWithoutTax() {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return 0;
      }

      let straightBetRiskAmount = +this.roundRobinTab.straightBetRiskAmount;

      let total = 0;

      if (straightBetRiskAmount && this.isBetween(straightBetRiskAmount)) {
        // BE güncellemesinden sonra checked lar dönmeli.
        //total += this.betModel.bet.line_selections.filter(s => isChecked(s.id)).length;
        total += this.checkedSelections.length * straightBetRiskAmount;
      }

      total += this.getTotalRiskForRR2();

      return this.roundAmount(total);
    },
    getTotalBetsCount() {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return 0;
      }
      const straightBetRiskAmount = +this.roundRobinTab.straightBetRiskAmount;

      let total = 0;

      if (straightBetRiskAmount && this.isBetween(straightBetRiskAmount)) {
        // BE güncellemesinden sonra checked lar dönmeli.
        //total += this.betModel.bet.line_selections.filter(s => isChecked(s.id)).length;
        total += this.checkedSelections.length;
      }

      if (this.roundRobinTab.roundRobinsAmounts) {
        const rrs = { ...this.roundRobinTab.roundRobinsAmounts };

        total += Object.entries(rrs)
          .filter(([_, value]) => !!value)
          .filter(([_, value]) => this.isBetween(value))
          .reduce((acc, curr) => acc + this.getParlayCountFromOptions(curr[0]), 0);
      }

      return total;
    },
    lineChecked(bet, selection) {
      setChecked(selection.selection_identifier);
      this.notifyBetSlip(bet);
      this.getNewBetOptions();
    },
    onStraightRiskChange(inputValue) {
      this.setRRStraightBetRiskAmount(inputValue);
    },
    // hold map in store {[parlay_size]: inputValue}
    onRRRiskChange(inputValue, parlay_size) {
      inputValue = +inputValue;
      this.setRRFoldBeRiskAmount({ inputValue, parlay_size });
    },
    getTranslationForFold(size) {
      const langMap = {
        2: 'BetSlip.RoundRobin.Double',
        3: 'BetSlip.RoundRobin.Triple',
      };
      const str = langMap[size] || 'BetSlip.RoundRobin.Fold';
      return this.$t(str, [size]);
    },
    getParlayCountFromOptions(parlay_size) {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return null;
      }
      return snq(
        () => this.betOptionsResponse.options.available_types.find((p) => p.parlay_size === +parlay_size).parlay_count,
        0,
      );
    },
    parlaysToReturn(size) {
      const value = this.totalWinFromParlay(size).value;

      return {
        text: `${this.currencySymbol} ${value.toFixed(2)}`,
        value: value,
      };
    },
    isBetween(value) {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return false;
      }
      return true;
      return (
        value >= Math.min(this.betOptionsResponse.options.limits.min_bet, this.getLocationMinBet) &&
        value <= this.betOptionsResponse.options.limits.max_bet
      );
    },
    infoClick(parlay_size) {
      this.$refs['preview_' + parlay_size][0].openModal();
    },
    getCombins(bet, parlay_size) {
      const comb = getRoundRobinCombinations(bet.Selections, parlay_size);
      return comb;
    },
    totalWinFromParlay(parlay_size) {
      const totalFromRR = this.getCombins(this.betModel[0], parlay_size);

      const totalFromCombin =
        totalFromRR.reduce((acc1, curr1) => {
          return acc1 + +curr1.reduce((acc2, curr2) => acc2 * this.americanToDecimal(curr2.Odd), 1);
        }, 0) *
        this.$taxHelper.applyTaxToRiskInputHidden({
          input_risk_amount: this.roundRobinTab.roundRobinsAmounts[parlay_size],
        });

      return {
        text: `${this.currencySymbol} ${snq(() => totalFromCombin.toFixed(2))}`,
        value: totalFromCombin,
      };
    },
    totalYankeeMatches() {
      const hasError = !this.betOptionsResponse.IsSuccess;
      if (hasError) {
        return [];
      }

      const totalFromYankee = this.betModel[0].options.available_types
        .map((type) => this.getCombins(this.betModel[0], type.parlay_size))
        .reduce((a, b) => a.concat(b), []);

      return totalFromYankee;
    },
    totalWinFromYankee2() {
      var totalFromYankee = this.totalYankeeMatches();
      const totalFromCombin =
        totalFromYankee.reduce((acc1, curr1) => {
          return acc1 + +curr1.reduce((acc2, curr2) => acc2 * this.americanToDecimal(curr2.Odd), 1);
        }, 0) * this.roundRobinTab.roundRobinsAmounts['99'];

      return {
        text: `${this.currencySymbol} ${snq(() => totalFromCombin.toFixed(2))}`,
        value: totalFromCombin,
      };
    },

    totalWinFromYankee2WithoutTaxes() {
      var totalFromYankee = this.totalYankeeMatches();
      let totalFromCombin =
        totalFromYankee.reduce((acc1, curr1) => {
          return acc1 + +curr1.reduce((acc2, curr2) => acc2 * this.americanToDecimal(curr2.Odd), 1);
        }, 0) *
        this.$taxHelper.applyTaxToRiskInputHidden({
          input_risk_amount: this.roundRobinTab.roundRobinsAmounts['99'],
        });

      if (totalFromCombin < 0) totalFromCombin = 0;

      return {
        text: `${this.currencySymbol} ${snq(() => totalFromCombin.toFixed(2))}`,
        value: totalFromCombin,
      };
    },
    totalWinFromYankee() {
      if (!this.betModel.IsSuccess) {
        return 0;
      }
      return this.betModel[0].options.available_types.reduce(
        (a, c) => a + c.parlay_count * this.roundRobinTab.roundRobinsAmounts['99'],
        0,
      );
    },
    getYankeeName() {
      let length = this.checkedSelections.length;
      length = length >= 9 ? 9 : length;
      return this.$t('BetSlip.RoundRobin.YankeeText-' + length.toString());
    },
    setAll() {
      const availableParlays = this.betModel[0].options.available_types.map((type) => type.parlay_size);

      if (this.canDoStraightBet) {
        this.setRRStraightBetRiskAmount(this.allBetAmount);
      }
      Object.keys(this.roundRobinTab.roundRobinsAmounts).forEach((k) => {
        if (availableParlays.includes(+k)) {
          this.setRRFoldBeRiskAmount({
            inputValue: this.allBetAmount,
            parlay_size: k,
          });
        }
      });
    },
    getAllParlayCounts() {
      if (!this.betModel[0].IsSuccess) {
        return 0;
      }

      return this.betModel[0].options.available_types
        .filter((a) => +a.parlay_size !== 99)
        .reduce((a, c) => a + c.parlay_count, 0);
    },
  },
  created() {
    // this.betOptionsResponse.input_risk_amount = null;
    // this.betOptionsResponse.input_win_amount = null;
    // this.betOptionsResponse.WagerType = 'round_robin';
    // this.betOptionsResponse.Selections.forEach((f) => {
    //   f.input_risk_amount = null;
    //   f.input_win_amount = null;
    // });
    // this.setBetOptionsResponse(this.betOptionsResponse);

    this.betModel = [this.getRoundRobins()];
    this.betModel[0].options = {
      available_types: [],
    };
    let totalParlayLength = 0;
    for (let index = 1; index <= this.betModel[0].Selections.length - 1; index++) {
      const element = this.betModel[0].Selections[index];
      const comb = this.getCombins(this.betModel[0], index + 1);
      totalParlayLength += comb.length;
      this.betModel[0].options.available_types.push({
        parlay_count: comb.length,
        parlay_size: index + 1,
      });
    }

    if (this.betModel[0].Selections.length > 3) {
      this.betModel[0].options.available_types.push({
        parlay_count: totalParlayLength,
        parlay_size: 99,
      });
    }

    this.fillRoundRobinData([]);
  },
  mounted() {
    this.updateBetFreeWager(0);
  },
};
</script>

<style lang="scss">
.setter-wrapper {
  --rightWidth: 20px;

  font-size: 12px;

  .title {
    font-weight: bold;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  .title-right {
    text-align: right;
    padding-right: 45px;
  }

  .single-area {
    margin-bottom: 10px;

    .return {
      padding-left: 30px;
      margin-top: 5px;
    }

    .single-area-right {
      display: flex;

      .type {
        font-size: 13px;
      }

      .factor {
        width: 20px;
        flex-shrink: 0;
        margin-right: 10px;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .input {
        width: 100%;
        margin-right: 10px;
      }

      .info {
        width: var(--rightWidth);
        flex-shrink: 0;
        align-self: stretch;
        display: flex;
        align-items: center;
        cursor: pointer;
      }
    }
  }
}
.bgColorWhite {
  background-color: #FFFFFF !important;
}
</style>
